import(/* webpackMode: "eager", webpackExports: ["PredictionForecast"] */ "/app/src/components/prices/PredictionForecast.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SupportResistance"] */ "/app/src/components/prices/SupportResistance.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Tooltip"] */ "/app/src/components/prices/Tooltip.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["YearlyForecast"] */ "/app/src/components/prices/YearlyForecast.tsx");
